export default __webpack_public_path__ + "static/media/iris-white.61205a22.svg";